import { render, staticRenderFns } from "./AddFacilityDetails.vue?vue&type=template&id=35211b8a"
import script from "./AddFacilityDetails.vue?vue&type=script&lang=js"
export * from "./AddFacilityDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports